import { HttpContextToken } from '@angular/common/http';

export const SKIP_GLOBAL_ERROR_HANDLER = new HttpContextToken<boolean>(() => false);

export const SKIP_GLOBAL_401_REDIRECT = new HttpContextToken<boolean>(() => false);

export const SKIP_GLOBAL_ERROR_TOAST = new HttpContextToken<boolean>(() => false);